// tooltipsの初期化
var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  return new bootstrap.Tooltip(tooltipTriggerEl)
})

// popoverの初期化
var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
  return new bootstrap.Popover(popoverTriggerEl)
})

// popoverの外をクリックで閉じる
//var popover = new bootstrap.Popover(document.querySelector('.popover-dismiss'), {
//  trigger: 'focus'
//})

window.openAlbumModal = function(timestamp, caption, permalink, mediaUrls, videoIndexes) {  
  let icon_html = ''

  $('#post-album-slide').empty();
  mediaUrls.forEach(function(url, index) {  
    if (url.includes('.jpg')) {
      if (videoIndexes.includes(index)) {
        icon_html = '<div class="other-image-icon"><i class="fa fa-play"></i></div>'
      } else {
        icon_html = ''
      }
      $('#post-album-slide').append('<div class="swiper-slide"><div class="slide-content"><img class="image" src="' + url + '">' + icon_html + '</div></div>');
    } else {
      $('#post-album-slide').append('<div class="swiper-slide"><div class="slide-content" style="text-align: -webkit-center;"><video class="video" controls width="240" height="300" muted poster="' + url + '"><source src="' + url + '" type="video/mp4">お使いのブラウザは動画タグに対応していません。</video></div></div>');
    }
  });
  $('#modal-album-timestamp').text(timestamp);
  $('#modal-album-caption').text(caption);
  $('#modal-aubum-media-url').attr('href', permalink);
}

window.openSingleImageModal = function(timestamp, caption, permalink, image_url) {
  $('#modal-media').attr('src', image_url);
  $('#modal-almum-modal-label').text(timestamp);
  $('#modal-post-text').text(caption);
  $('#modal-media-url').attr('href', permalink);
}
